<div class="w-100 float-left">
    <div class="b-b pb-2 w-100 mb-3 float-left align-v-center">
        <h5 class="medium m-0">{{ "tenantPreference" | translate }}</h5>
        <div class="ml-alert"></div>
        <div style="flex-grow: 1;"></div>
    </div>
    <div class="w-100 float-left light-bg p-3 mb-4">
        <div class="b-b pb-2 w-100 mb-3 float-left align-v-center">
            <h5 class="medium m-0">{{ "genSettings" | translate }}</h5>
            <div class="ml-alert"></div>
            <div style="flex-grow: 1;"></div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-12 float-left">
            <div class="w-100 float-left form-group">
                <label>
                    {{ "displayPreference" | translate }}
                    <span class="text-danger medium">*</span>:</label>
                <div class="align-v-center w-100 float-left">
                    <div class="col-lg-9 col-md-9 col-sm-6 col-12 float-left p-0">
                        <input type="number" name="displayPref"
                               onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57"
                               class="form-control" [(ngModel)]="displayPreferences" min="0">
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-6 col-12 float-left">
                        <p class="m-0 text-danger text-truncate">{{ num }}</p>
                    </div>
                </div>
            </div>
            <div class="w-100 float-left form-group">
                <label>{{ "monthStartDay" | translate }}:</label>
                <div class="align-v-center w-100 float-left">
                    <div class="col-lg-9 col-md-9 col-sm-6 col-12 float-left p-0">
                        <select class="form-control w-100" [(ngModel)]="monthStartDay" name="monthStartDay"
                                ngDefaultControl>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                            <option value="6">6</option>
                            <option value="7">7</option>
                            <option value="8">8</option>
                            <option value="9">9</option>
                            <option value="10">10</option>
                            <option value="11">11</option>
                            <option value="12">12</option>
                            <option value="13">13</option>
                            <option value="14">14</option>
                            <option value="15">15</option>
                            <option value="16">16</option>
                            <option value="17">17</option>
                            <option value="18">18</option>
                            <option value="19">19</option>
                            <option value="20">20</option>
                            <option value="21">21</option>
                            <option value="22">22</option>
                            <option value="23">23</option>
                            <option value="24">24</option>
                            <option value="25">25</option>
                            <option value="26">26</option>
                            <option value="27">27</option>
                            <option value="28">28</option>
                            <option value="29">29</option>
                            <option value="30">30</option>
                            <option value="31">31</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="float-left form-group">
                <label class="w-100 float-left">{{'updateEmpDisPic' | translate}}
                    <span class="text-danger medium">*</span>:</label>
                <div class="checkbox checkbox-primary float-left mr-4 align-v-center text-14x">
                    <input id="id_all" type="checkbox" name="allow" [checked]="allow == true"
                           (change)="allowPicture($event)"/>
                    <label for="id_all" class="mb-0 mr-1"></label> {{'allow' | translate}}
                </div>
            </div>

            <div class="float-left form-group">
                <label class="w-100 float-left">{{'THINGS_TO_DO' | translate}}:</label>
                <div class="checkbox checkbox-primary float-left mr-4 align-v-center text-14x">
                    <input id="id_thingstodo" type="checkbox" name="allow" [checked]="isToDoEnabled=='false'"
                           (change)="disableTodo($event)"/>
                    <label for="id_thingstodo" class="mb-0 mr-1"></label> {{'disabled' | translate}}
                </div>
            </div>

            <div class="float-left form-group">
                <label class="w-100 float-left">{{'PUSH_KPI_OPTION_ENABLED' | translate}}:</label>
                <div class="checkbox checkbox-primary float-left mr-4 align-v-center text-14x">
                    <input id="PUSH_KPI_OPTION_ENABLED_ID" type="checkbox" name="PUSH_KPI_OPTION_ENABLED_ID"
                           [checked]="pushKpiEnabled=='true'" (change)="updatePushKpiOption($event)"/>
                    <label for="PUSH_KPI_OPTION_ENABLED_ID" class="mb-0 mr-1"></label> {{'enabled' | translate}}
                </div>
            </div>

        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-12 float-left">
            <div class="w-100 float-left form-group">
                <label>{{ "weekStartDay" | translate }}:</label>
                <select class="form-control w-100" [(ngModel)]="weekStartDay" name="weekStartDay" ngDefaultControl>
                    <option value="Sunday">{{ "sunday" | translate }}</option>
                    <option value="Monday">{{ "monday" | translate }}</option>
                    <option value="Tuesday">{{ "tuesday" | translate }}</option>
                    <option value="Wednesday">{{ "wednesday" | translate }}</option>
                    <option value="Thursday">{{ "thursday" | translate }}</option>
                    <option value="Friday">{{ "friday" | translate }}</option>
                    <option value="Saturday">{{ "saturday" | translate }}</option>
                </select>
            </div>

            <div class="w-100 float-left form-group">
                <label>{{'userCanShareAnnWith' | translate}}:</label>
                <div class="align-v-center w-100 float-left">
                    <div class="col-lg-12 col-md-9 col-sm-6 col-12 float-left p-0">
                        <select class="form-control w-100" [(ngModel)]="userCanShareWith" name="userCanShareWith"
                                ngDefaultControl>
                            <option value="EVERYONE">{{ "everyone" | translate }}</option>
                            <option value="MY_TEAM">{{ "myTeam" | translate }}</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="w-100 float-left form-group">
                <label class="w-100 float-left">{{ "preferDate" | translate }}:</label>
                <div class="form-group float-left mr-4 align-v-center text-14x">
                    <input type="radio" id="1" checked name="radio-group" [(ngModel)]="dateFormat" value="yyyy-MM-dd"/>
                    <label for="1" class="normal"> YYYY-MM-DD </label>
                </div>
                <div class="float-left mr-4 align-v-center text-14x">
                    <input type="radio" id="2" name="radio-group" [(ngModel)]="dateFormat" value="MM-yyyy-dd"/>
                    <label for="2" class="normal"> MM-YYYY-DD </label>
                </div>
                <div class="float-left mr-4 align-v-center text-14x">
                    <input type="radio" id="3" name="radio-group" [(ngModel)]="dateFormat" value="dd-MM-yyyy"/>
                    <label for="3" class="normal"> DD-MM-YYYY </label>
                </div>
            </div>
            <div class="float-left form-group d-flex align-items-center">
                <label class="w-100 float-left">{{'canCoachMultipleUsers' | translate}}:</label>
                <div class="checkbox checkbox-primary float-left mr-4 align-v-center text-14x">
                    <input id="id_canCoachMultipleUsers" type="checkbox" name="allow"
                           [checked]="canCoachMultipleUsers == 'true'" (change)="disableCoachMultipleUsers($event)"/>
                    <label for="id_canCoachMultipleUsers" class="ml-2"></label>
                </div>
            </div>
        </div>
    </div>

    <div class="w-100 float-left light-bg p-3 mb-4">
        <div class="b-b pb-2 w-100 mb-3 float-left align-v-center">
            <h5 class="medium m-0">{{ "sharingOption" | translate }}</h5>
            <div class="ml-alert"></div>
            <div style="flex-grow: 1;"></div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-12 float-left">
            <div class="w-100 float-left form-group">
                <label>{{ "userCanShare" | translate }}
                    <span class="text-danger medium">*</span>:</label>
                <select class="form-control w-100" [(ngModel)]="shareWith" name="shareWith">
                    <option value="EVERYONE">{{ "everyone" | translate }}</option>
                    <option value="MY_TEAM">{{ "myTeam" | translate }}</option>
                    <option value="MY_WORK_CIRCLE">{{ "myCircle" | translate }}</option>
                    <option value="MY_IMMEDIATE_WORK_CIRCLE">{{ "myImmediateWorkCircle" | translate }}</option>
                </select>
            </div>
            <div class="w-100 float-left form-group">
                <div class="d-flex align-items-center">
                    <p class="mb-0 mr-2">{{ "CommentOnAdminAnnouncement" | translate }}</p>
                    <div class="checkbox checkbox-primary float-left mr-4 align-v-center text-14x">
                        <input id="id4" type="checkbox" name="isCommentDisableForAdminPost"
                               [(ngModel)]="isCommentDisableForAdminPost"/>
                        <label for="id4" class="mb-0 mr-1"></label>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-12 float-left">
            <label class="w-100 float-left">{{ "shareCommentDiscuss" | translate }}
                <span class="text-danger medium">*</span>:</label>
            <div class="checkbox checkbox-primary float-left mr-4 align-v-center text-14x">
                <input id="id1" type="checkbox" name="share" [(ngModel)]="share"/>
                <label for="id1" class="mb-0 mr-1"></label> {{ "share" | translate }}
            </div>
            <div class="checkbox checkbox-primary float-left mr-4 align-v-center text-14x">
                <input id="likeId" type="checkbox" name="like" [(ngModel)]="like"/>
                <label for="likeId" class="mb-0 mr-1"></label> {{ "like" | translate }}
            </div>
            <div class="checkbox checkbox-primary float-left mr-4 align-v-center text-14x">
                <input id="id2" type="checkbox" name="comment" [(ngModel)]="comment"/>
                <label for="id2" class="mb-0 mr-1"></label> {{ "comment" | translate }}
            </div>
            <div class="checkbox checkbox-primary float-left mr-4 align-v-center text-14x">
                <input id="id3" type="checkbox" name="discuss" [(ngModel)]="discuss"/>
                <label for="id3" class="mb-0 mr-1"></label> {{ "discuss" | translate }}
            </div>

        </div>
    </div>

    <div class="w-100 float-left light-bg p-3 mb-4">
        <div class="b-b pb-2 w-100 mb-3 float-left align-v-center">
            <h5 class="medium m-0">{{ "recordPerPage" | translate }}</h5>
            <div class="ml-alert"></div>
            <div style="flex-grow: 1;"></div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-12 float-left">
            <label>{{ "noPageToDisplayHub" | translate }}
                <span class="text-danger medium">*</span>:</label>
            <input type="number" name="recordsPerPage"
                   onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57"
                   class="form-control" [(ngModel)]="paginationValue" min="1" max="100"/>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-12 float-left">
            <label>{{ "noPageGrid" | translate }}
                <span class="text-danger medium">*</span> :</label>
            <input type="number" name="noPageGridDis"
                   onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57"
                   class="form-control" [(ngModel)]="paginationValueGrid" min="1" max="100"/>
        </div>
    </div>

    <div class="w-100 float-left light-bg p-3 mb-4">
        <div class="b-b pb-2 w-100 mb-3 float-left align-v-center">
            <h5 class="medium m-0">{{ "otherSettings" | translate }}</h5>
            <div class="ml-alert"></div>
            <div style="flex-grow: 1;"></div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-12 float-left">
            <div class="w-100 float-left form-group">
                <label>{{ "applicableUmo" | translate }}:</label>
                <input class="form-control" name="uoms" [(ngModel)]="applicableUOMValue"/>
            </div>
            <div class="w-100 float-left form-group">
                <label>{{ "logoutFromMobile" | translate }} :</label>
                <input type="number" name="logoutMD" min="0"
                       onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57"
                       class="form-control" [(ngModel)]="logoutVal"/>
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-12 float-left">
            <label>{{ "howManyExtraMonthsCanShowForDateBased" | translate }} :</label>
            <input type="number" name="allowedEmail" min="0" max="6"
                   onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57"
                   class="form-control" [(ngModel)]="numberOfMonthsDateTargetCanExceed"/>
        </div>

    </div>

    <div class="w-100 float-left light-bg p-3 mb-4">
        <div class="b-b pb-2 w-100 mb-3 float-left align-v-center">
            <h5 class="medium m-0">Configuration Settings</h5>
            <div class="ml-alert"></div>
            <div style="flex-grow: 1;"></div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-12 float-left">
            <div class="w-100 float-left form-group">
                <label> Upload Tenant logo:</label>
                <div class="align-v-center w-100 float-left">
                    <div class="col-lg-9 col-md-9 col-sm-6 col-12 float-left p-0">
                        <input type="file" name="pic" class="form-control" (change)="fileChange($event)"
                               accept=".jpg,.png,.svg,.svgz" #fileInput/>
                        <div class="align-v-center justify-content-end">
                            <small class="text-primary">Resolution: 160*40px; </small>
                            <small class="ml-2 text-primary">size limit: 5mb</small>
                        </div>
                    </div>
                </div>

                <div *ngIf="allowBI">
                    <label> Upload BI logo:</label>
                </div>
                <div class="align-v-center w-100 float-left" *ngIf="allowBI">
                    <div class="col-lg-9 col-md-9 col-sm-6 col-12 float-left p-0">
                        <input type="file" name="pic" class="form-control" (change)="BIFileChange($event)"
                               accept=".jpg,.png,.svg,.svgz" #fileInput/>
                        <div class="align-v-center justify-content-end">
                            <small class="text-primary">Resolution: 160*40px; </small>
                            <small class="ml-2 text-primary">size limit: 5mb</small>
                        </div>
                    </div>
                </div>

                <div class="align-v-center w-100 pt-3">
                    <div class="checkbox checkbox-primary">
                        <input id="checkbox6" type="checkbox" (change)="allowSameLogo($event)" checked>
                        <label for="checkbox6" class="mb-md-0"></label>
                    </div>
                    <label class="ml-2">{{'sameLogoToBI' | translate}}</label>
                </div>

            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-12 float-left">
            <div class="float-left form-group">
                <label class="mr-3 float-left">{{'SCORECARD_HISTORY' | translate}}:</label>
                <div class="checkbox checkbox-primary float-left mr-4 align-v-center text-14x">
                    <input id="id_scorecardhistory" type="checkbox" name="allow"
                           [checked]="isScorecardHistoryEnabled == 'false'" (change)="disableScorecardHistory($event)"/>
                    <label for="id_scorecardhistory" class="mb-0 mr-1"></label> {{'disabled' | translate}}
                </div>
            </div>
            <div class="float-left form-group">
                <label class="mr-3 float-left">{{'SHOW_DISPLAY_PICTURE_AS_TENANT_LOGO' | translate}}:</label>
                <div class="checkbox checkbox-primary float-left mr-4 align-v-center text-14x">
                    <input id="id_showTenantLogoAsDisplayPicture" type="checkbox" name="showTenantLogoAsDisplayPicture"
                           [(ngModel)]="isDisplayTenantLogoInUserPicture"/>
                    <label for="id_showTenantLogoAsDisplayPicture" class="mb-0 mr-1"></label>
                </div>
            </div>
            <div class="float-left form-group">
                <label class="mr-3 float-left">{{'SHOW_OVERALL_SCORE_AS_DESCRIPTION' | translate}}:</label>
                <div class="checkbox checkbox-primary float-left mr-4 align-v-center text-14x">
                    <input id="id_OverallScoreAsDescription" type="checkbox" name="id_OverallScoreAsDescription"
                           [(ngModel)]="isOverallScoreAsDescription"/>
                    <label for="id_OverallScoreAsDescription" class="mb-0 mr-1"></label>
                </div>
            </div>

            <div class="float-left form-group">
                <label class="mr-3 float-left">{{'ROUND_OFF_OVERALLSCORE' | translate}}:</label>
                <div class="checkbox checkbox-primary float-left mr-4 align-v-center text-14x">
                    <input id="round_off_overallScore" type="checkbox" name="round_off_overallScore"
                           [(ngModel)]="isRoundOffOverallScore"/>
                    <label for="round_off_overallScore" class="mb-0 mr-1"></label>
                </div>
            </div>

            <div class="float-left form-group">
                <label class="mr-3 float-left">{{'TO_DO_CARD_FOR_TASK_ASSIGNED' | translate}}:</label>
                <div class="checkbox checkbox-primary float-left mr-4 align-v-center text-14x">
                    <input id="id_TO_DO_TASK_ASSIGNED" type="checkbox" name="id_TO_DO_TASK_ASSIGNED"
                           [(ngModel)]="isToDoTaskAssigned"/>
                    <label for="id_TO_DO_TASK_ASSIGNED" class="mb-0 mr-1"></label>
                </div>
            </div>

        </div>

        <div class="w-100 float-left" *ngIf="client == 'KEA'">
            <div class="col-lg-6 col-md-6 col-sm-6 col-12 float-left">
                <div class="w-100 float-left form-group">
                    <label> Upload Tenant Login logo:</label>
                    <div class="align-v-center w-100 float-left">
                        <div class="col-lg-9 col-md-9 col-sm-6 col-12 float-left p-0">
                            <input type="file" name="pic" class="form-control" (change)="logoFileChange($event)"
                                   accept=".jpg,.png,.svg,.svgz" #fileInput/>
                            <div class="align-v-center justify-content-end">
                                <small class="text-primary">Resolution: 180*60px; </small>
                                <small class="ml-2 text-primary">size limit: 5mb</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-12 float-left">
                <div class="w-100 float-left form-group">
                    <label>{{ "font" | translate }}:</label>
                    <select class="form-control w-100" [(ngModel)]="tenantFont" name="tenantFont" ngDefaultControl>
                        <option value="null">{{ "select" | translate }}</option>
                        <option value="Avenir-Regular">{{ "Avenir" | translate }}</option>
                        <option value="GothamBookRegular">{{ "Gotham Book" | translate }}</option>
                        <option value="Heavent">{{ "Heavent" | translate }}</option>
                    </select>
                    <div class="float-left form-group">
                        <label class="mr-3 float-left">{{'ENABLE_AVERAGE_OPTION_FOR_YTD_PROGRAM' | translate}}
                            :</label>
                        <div class="checkbox checkbox-primary float-left mr-4 align-v-center text-14x">
                            <input id="id_ENABLE_AVERAGE_OPTION_FOR_YTD_PROGRAM" type="checkbox"
                                   name="id_ENABLE_AVERAGE_OPTION_FOR_YTD_PROGRAM" [(ngModel)]="enableAverageOption"/>
                            <label for="id_ENABLE_AVERAGE_OPTION_FOR_YTD_PROGRAM" class="mb-0 mr-1"></label>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="w-100 float-left" *ngIf="client == 'SKYLARK'">
            <div class="col-lg-6 col-md-6 col-sm-6 col-12 float-left">
                <div class="w-100 float-left form-group">
                    <label> Upload Tenant Loader:</label>
                    <div class="align-v-center w-100 float-left">
                        <div class="col-lg-9 col-md-9 col-sm-6 col-12 float-left p-0">
                            <input type="file" name="pic" class="form-control" (change)="loaderFileChange($event)"
                                   accept=".gif" #fileInput/>
                            <div class="align-v-center justify-content-end">
                                <small class="text-primary">Only gif image: </small>
                                <small class="ml-2 text-primary">size limit: 5mb</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-12 float-left">
                <div class="w-100 float-left form-group">
                    <label>Analytics Token:</label>
                    <div class="align-v-center w-100 float-left">
                        <div class="col-lg-9 col-md-9 col-sm-6 col-12 float-left p-0">
                            <input type="text" name="token" [(ngModel)]="analyticsToken" class="form-control"/>
                            <div class="float-left form-group">
                                <label class="mr-3 float-left">Enable Analytics:</label>
                                <div class="checkbox checkbox-primary float-left mr-4 align-v-center text-14x">
                                    <input id="id_ENABLE_ANALYTICS" type="checkbox" name="id_ENABLE_ANALYTICS"
                                           [(ngModel)]="enableAnalytics"/>
                                    <label for="id_ENABLE_ANALYTICS" class="mb-0 mr-1"></label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="w-100 float-left mb-4">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12 float-left">
                <p>{{'showAnnualScore'|translate}}</p>
                <div class="checkbox checkbox-primary float-left mr-4 align-v-center text-14x">
                    <input id="employeeCheckbox" name="employeeCheckbox" type="checkbox"
                           [(ngModel)]="canEmployeeViewAnnualScore">
                    <label class="mb-0 mr-1" for="employeeCheckbox"></label>
                    {{'EMPLOYEE_ADMIN'|translate}}
                </div>
                <div class="checkbox checkbox-primary float-left mr-4 align-v-center text-14x">
                    <input id="supervisorCheckbox" name="supervisorCheckbox" type="checkbox"
                           [(ngModel)]="canSuperviosrViewAnnualScore">
                    <label class="mb-0 mr-1" for="supervisorCheckbox"></label>
                    {{'Supervisor'|translate}}
                </div>
                <div class="checkbox checkbox-primary float-left mr-4 align-v-center text-14x">
                    <input id="switchUserCheckbox" name="switchUserCheckbox" type="checkbox"
                           [(ngModel)]="canSwitchViewAnnualScore">
                    <label class="mb-0 mr-1" for="switchUserCheckbox"></label>
                    {{'empWithSwitchUserAccess'|translate}}
                </div>
                <!-- <div class="checkbox checkbox-primary float-left mr-4 align-v-center text-14x">
                    <input id="downloadCheckbox" name="downloadCheckbox" type="checkbox" [(ngModel)]="canReportViewAnnualScore">
                    <label class="mb-0 mr-1" for="downloadCheckbox"></label>
                    {{'inDownloadReport'|translate}}
                </div> -->
            </div>
        </div>


        <div class="w-100 float-left light-bg p-3 mb-4" *ngIf="client == 'KEA'">
            <div class="b-b pb-2 w-100 mb-3 float-left align-v-center">
                <h5 class="medium m-0">Theme Settings</h5>
                <div class="ml-alert"></div>
                <div style="flex-grow: 1;"></div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-12 float-left mb-4">
                <div class="w-100 float-left form-group">
                    <label> Primary Color:</label>
                </div>
                <input [(colorPicker)]="primaryColor" [style.background]="primaryColor" [cpOutputFormat]="'rgba'"
                       [cpAlphaChannel]="'disabled'"/>
            </div>
        </div>
        <div class="w-100 float-left light-bg p-3 mb-4">
            <div class="b-b pb-2 w-100 mb-3 float-left align-v-center">
                <h5 class="medium m-0">Strategy</h5>
                <div class="ml-alert"></div>
                <div style="flex-grow: 1;"></div>
            </div>
            <div class="align-v-center w-100 pt-3">
                <div class="checkbox checkbox-primary">
                    <input id="statCheckbox1" type="checkbox" [(ngModel)]="allowMultipleStrategy">
                    <label for="statCheckbox1" class="mb-md-0"></label>
                </div>
                <label class="ml-2"> {{'allowMultipleStrategy' | translate}}</label>
            </div>
        </div>
        <div class="w-100 float-left light-bg p-3 mb-4">
            <div class="b-b pb-2 w-100 mb-3 float-left align-v-center">
                <h5 class="medium m-0">KPI Settings</h5>
                <div class="ml-alert"></div>
                <div style="flex-grow: 1;"></div>
            </div>
            <div>{{'subordinateScorecardChangeOption' | translate}}</div>
            <div class=" w-100 pt-3">
                <div class="align-v-center mb-4">
                    <div class="checkbox checkbox-primary float-left align-v-center text-14x">
                        <input id="changeCheckBox1" type="checkbox" [(ngModel)]="reflectChanges">
                        <label for="changeCheckBox1" class="mb-md-0"></label>
                    </div>
                    <label class="ml-2"> {{'reflectChanges' | translate}}</label>
                </div>

                <div class="align-v-center mb-2">
                    <div class="checkbox checkbox-primary float-left align-v-center text-14x">
                        <input id="changeCheckBox2" type="checkbox" [(ngModel)]="changeRelationship">
                        <label for="changeCheckBox2" class="mb-md-0"></label>
                    </div>
                    <label class="ml-2"> {{'changeRelationship' | translate}}</label>
                </div>

                <div class="align-v-center mb-2">
                    <div class="checkbox checkbox-primary float-left align-v-center text-14x">
                        <input id="changeCheckBox3" type="checkbox" [(ngModel)]="resetToCreated">
                        <label for="changeCheckBox3" class="mb-md-0"></label>
                    </div>
                    <label class="ml-2"> {{'resetToCreated' | translate}}</label>
                </div>

                <!--<div class="align-v-center mb-2">
                    <div class="checkbox checkbox-primary float-left align-v-center text-14x">
                        <input id="changeCheckBox4" type="checkbox" [(ngModel)]="changeAndReset">
                        <label for="changeCheckBox4" class="mb-md-0"></label>
                    </div>
                    <label class="ml-2"> {{'changeAndReset
                        ' | translate}}</label>
                </div>-->
            </div>
        </div>

        <div class="w-100 float-right p-3 mb-4">
            <button class="btn btn-primary float-right" (click)="formatPayload()">
                {{ "Save" | translate }}
            </button>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/tools/tenantPreference.html